import { Center, OrbitControls, shaderMaterial, Sparkles, useGLTF, useTexture } from '@react-three/drei'
import portalVertexShader from './shaders/portal/vertex.glsl'
import portalFragmentShader from './shaders/portal/fragment.glsl'
import * as THREE from 'three'
import { extend, useFrame } from '@react-three/fiber'
import { useRef } from 'react'

const PortalMaterial = shaderMaterial({
    uTime: 0,
    uColorStart: new THREE.Color('yellow'),
    uColorEnd: new THREE.Color('pink')
}, portalVertexShader, portalFragmentShader)

extend({ PortalMaterial })

export default function Experience()
{
    const { nodes } = useGLTF('./model/portal.glb')

    const bakedTexture = useTexture('./model/baked.jpg')
    bakedTexture.flipY = false

    const portalMaterial = useRef()
    useFrame((state, delta) => {
        portalMaterial.current.uTime += delta
    })

    return <>

        <color args={ [ '#030202' ] } attach='background' />

        <OrbitControls
            makeDefault
            enablePan={ false }
            minPolarAngle={ Math.PI / 6 }
            maxPolarAngle={ Math.PI / 2 }
            minAzimuthAngle={ -Math.PI / 4 }
            maxAzimuthAngle={ Math.PI / 4 }
            minDistance={ 1 }
            maxDistance={ 15 }
        />
        <Center>
            <mesh geometry={ nodes.baked.geometry }>
                <meshBasicMaterial map={ bakedTexture } />
            </mesh>

            <mesh
                geometry={ nodes.poleLightA.geometry }
                position={ nodes.poleLightA.position }
            >
                <meshBasicMaterial color='white' />
            </mesh>
            <mesh
                geometry={ nodes.poleLightB.geometry }
                position={ nodes.poleLightB.position }
            >
                <meshBasicMaterial color='white' />
            </mesh>

            <mesh
                geometry={ nodes.portalLight.geometry }
                position={ nodes.portalLight.position }
                rotation={ nodes.portalLight.rotation }
            >
                <portalMaterial ref={ portalMaterial }/>
            </mesh>

            <Sparkles
                size={ 6 }
                scale={ [ 4, 2, 4 ] }
                position-y={ 1 }
                speed={ 0.2 }
                count={ 40 }
            />

        </Center>
    </>
}